import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import React from "react";
export var Content = function(param) {
    var className = param.className, children = param.children;
    return /*#__PURE__*/ _jsx("main", {
        className: classNames("flex-1 w-full max-w-4xl py-4 md:py-6 space-y-4 sm:space-y-6 m-auto", className),
        children: children
    });
};
